import MileageRate, {
  IRS_MILEAGE_RATES,
  resolveRateForDate,
} from "../../../classes/MileageRate";
import { db } from "../../../boot/firebase";
import { collection, deleteDoc, doc, setDoc } from "firebase/firestore";

export const GET_MILEAGE_RATE = ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: MileageRate,
    path: MileageRate.getPath(id),
    stateKey: "mileageRates",
    stateID: id,
    id,
  });
};

export const GET_MILEAGE_RATES = (
  { dispatch },
  { where, limit, pagination }
) => {
  return dispatch("GET_COLLECTION", {
    converter: MileageRate,
    path: MileageRate.getPath(),
    stateKey: "mileageRates",
    where,
    limit,
    pagination,
  });
};

export const LISTEN_MILEAGE_RATES = (
  { dispatch },
  { where, pagination, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: MileageRate,
    path: MileageRate.getPath(),
    stateKey: "mileageRates",
    where,
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SAVE_MILEAGE_RATE = async ({ commit, state }, { id, data }) => {
  const now = new Date();
  const user = state.user;

  const rate = new MileageRate(id, data);

  if (!id) {
    rate.data.created = now;
    rate.data.createdBy = user.id;

    const ref = doc(collection(db, MileageRate.getPath()));
    rate.id = ref.id;

    await setDoc(ref, rate.toFirestore());
  } else {
    rate.data.modified = now;
    rate.data.modifiedBy = user.id;

    await setDoc(doc(db, MileageRate.getPath(id)), rate.toFirestore());
  }

  commit("SET", { stateKey: "mileageRates", stateID: rate.id, doc: rate });

  return rate;
};

export const DELETE_MILEAGE_RATE = async ({ commit }, id) => {
  if (!id) return;
  await deleteDoc(doc(db, MileageRate.getPath(id)));
  commit("REMOVE", { stateKey: "mileageRates", stateID: id });
};

/**
 * Get the mileage rate ($/mile) in effect on a given date (defaults to today).
 * Resolves the most recent stored rate whose effective date is on or before the
 * reference date, which supports mid-year rate changes. Falls back to the
 * hardcoded IRS_MILEAGE_RATES when no rate is stored.
 */
export const GET_RATE_FOR_DATE = async (
  { state, dispatch },
  referenceDate = new Date()
) => {
  // Check if we already have rates loaded; if not, fetch them.
  let rates = Object.values(state.mileageRates);
  if (rates.length === 0) {
    await dispatch("GET_MILEAGE_RATES", {});
    rates = Object.values(state.mileageRates);
  }

  // Prefer a stored rate resolved by effective date.
  const stored = resolveRateForDate(
    rates.map((r) => r.data),
    referenceDate
  );
  if (stored && Number(stored.ratePerMile) > 0) {
    return Number(stored.ratePerMile);
  }

  // Fall back to the hardcoded IRS rates (also effective-date resolved).
  const fallback =
    resolveRateForDate(IRS_MILEAGE_RATES, referenceDate) ||
    // If the reference date precedes every known rate, use the earliest.
    [...IRS_MILEAGE_RATES].sort(
      (a, b) => new Date(a.effectiveDate) - new Date(b.effectiveDate)
    )[0];
  return fallback ? fallback.ratePerMile : 0.67;
};
